export const LOCATION_LIST_CLEAR = 'LOCATION_LIST_CLEAR';
export const LOCATION_LIST = 'LOCATION_LIST';
export const LOCATION_GET = 'LOCATION_GET';
export const LOCATION_GET_CLEAR = 'LOCATION_GET_CLEAR';

export const LOCATION_LIST_CUSTOMER = 'LOCATION_LIST_CUSTOMER';